import React from "react";
import "../css/loader.css";
const Loader = () => {
  return (
    <div className="center-align-container" data-testid="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
